import { FC } from "react";
import { IonProgressBar } from "@ionic/react";
import { AllieProgressBarProps } from "./ProgressBar.types";

export const AllieProgressBar: FC<AllieProgressBarProps> = (props) => (
  <IonProgressBar {...props} />
);
